export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'estmatRepQty',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    title: that.$l('form_label_estmatRepQty') || '需求数量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'salesTitle',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    title: that.$l('form_label_salesTitle') || '店铺售卖标题',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_amzSkuNo') || '亚马逊SKU编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'asinCode',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_asinCode') || 'ASIN编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fnskuCode',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('form_label_fnskuCode') || 'FNSKU编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'etaDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    title: that.$l('form_label_etaDate') || '预计FBA到货日期',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'orderDate',
    headerAlign: 'center',
    align: 'center',
    width: 140,
    title: that.$l('form_label_orderDate') || '预计采购下单日期',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'last30DaysPerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_last30DaysPerDay') || '过去30天日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'last14DaysPerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_last14DaysPerDay') || '过去14天日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'last7DaysPerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_last7DaysPerDay') || '过去7天日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'estimatePerDay',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_estimatePerDay') || '预估日销售量',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fbaQty',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_fbaQty') || 'FBA库存',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'fbaDaysOfSupply',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_fbaDaysOfSupply') || 'FBA库存可售天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'productionLeadTime',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_productionLeadTime') || '成品生产周期天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'shipmentLeadTime',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    title: that.$l('form_label_shipmentLeadTime') || '物流运输周期天数',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
